import {CalculatorInitialValuesType} from "../types/CalculatorInitialValuesType";
import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";

export const getCalculatorInitialValues = (calculatorRangesOptions: ICalculatorOptions[]): CalculatorInitialValuesType => {
    return calculatorRangesOptions.reduce(
        (acc, curr) => {
            return {...acc, [curr.valueType]: curr.values.init || curr.values.lower};
        },
        {} as {[key in CalculatorValueType]: number}
    );
};
import {CalculatorInitialValuesType} from "../types/CalculatorInitialValuesType";
import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";

export const getCalculatorInitialValues = (calculatorRangesOptions: ICalculatorOptions[]): CalculatorInitialValuesType => {
    return calculatorRangesOptions.reduce(
        (acc, curr) => {
            return {...acc, [curr.valueType]: curr.values.init || curr.values.lower};
        },
        {} as {[key in CalculatorValueType]: number}
    );
};
